import { Component, ViewChild } from '@angular/core';
import {FabContainer, IonicPage, ModalController, NavController, NavParams} from 'ionic-angular';
import { Platform, MenuController, App} from 'ionic-angular';
import { ServiceProvider } from '../../providers/service/service';
import { Storage } from '@ionic/storage';
import { AlertController, Nav, ToastController, LoadingController } from 'ionic-angular';
import {EnquiryFormPage} from "../enquiry-form/enquiry-form";
import { SocialSharing } from '@ionic-native/social-sharing';
import {AddAppointmentPage} from "../add-appointment/add-appointment";
import {DomSanitizer} from "@angular/platform-browser";
import { WebIntent } from '@ionic-native/web-intent';
import {DataCallLogPage} from "../data-call-log/data-call-log";
import {InAppBrowser} from "@ionic-native/in-app-browser";
import { Contacts, Contact, ContactField, ContactName } from '@ionic-native/contacts';
import {AddJustdialDataPage} from "../add-justdial-data/add-justdial-data";

@Component({
  selector: 'page-guest',
  templateUrl: 'guest.html',
})
export class GuestPage {

  FUserId:any;
  UserRights:any;
  SchoolData = {};
  TypeData = {};
  School = 'All';
  CommonTypeId = 'Web_Enquiry';
  FilterOption = 'Date';
  Date: any;
  DisplayDate = "";
  monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  ArchiveStatusItem:any;
  ArchiveStatus:any;

  EnquiryData:any;
  datanotfound:any;
  Active='Pending';
  IsArchiveData={};

  constructor(public navCtrl: NavController, public navParams: NavParams, public service: ServiceProvider, public platform:Platform, menuCtrl:MenuController, public loadingCtrl: LoadingController, public toastCtrl: ToastController,
              public storage: Storage,
              public _app: App,
              public modalCtrl: ModalController,public alertCtrl: AlertController,
              private contacts: Contacts,
              private sanitizer: DomSanitizer,
              private socialSharing: SocialSharing,
              public iab: InAppBrowser,
              private webIntent:WebIntent) {
    //get school rights only [{GWW:true,GEIS:false}]
    this.platform.ready().then(() => {
      this.Date = new Date();
      this.DisplayDate = this.Date.getDate() + "-" + this.monthNames[this.Date.getMonth()] + "-" + this.Date.getFullYear();
      this.Date = this.Date.toISOString();

      this.SchoolData = {
        "All": 0,
        "GWW": 2,
        "GWE": 3,
        "GEIS": 1
      };

      this.IsArchiveData = {
        "Pending": 1,
        "Archive": 3,
      };

      Promise.all([this.storage.get('LoginData')]).then(values => {
        this.FUserId = values[0]['FUserId'];
        console.log(this.FUserId);
        this.get_user_rights(this.FUserId);
        this.load_archive_status();
      });
    });
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad GuestPage');
  }


  presentToast(msg){
    let toast = this.toastCtrl.create({
      message: msg,
      duration: 3000,
      position: 'bottom'
    });
    toast.present();
  }

  add_filter(f) {
    console.log(f);
    if (f == 'All') {
      this.FilterOption = 'All';
      this.DisplayDate = "";
     this.loadvalues(this.SchoolData[this.School], this.FUserId);
    } else {
      this.FilterOption = 'Date';
      var Date1 = new Date(this.Date);
      console.log(Date1.getDate() + "-" + this.monthNames[Date1.getMonth()] + "-" + Date1.getFullYear());
      this.DisplayDate = Date1.getDate() + "-" + this.monthNames[Date1.getMonth()] + "-" + Date1.getFullYear();
      console.log("DisplayDate ", this.DisplayDate);
     this.loadvalues(this.SchoolData[this.School], this.FUserId);
      console.log('Date call');
    }
  }

  Prev(date) {
    this.Date = new Date(date);
    this.Date.setDate(this.Date.getDate(date) - 1);
    this.Date = this.Date.toISOString();
    //in this case ion-datetime will call ionChange event
  }

  Next(date) {
    this.Date = new Date(date);
    this.Date.setDate(this.Date.getDate(date) + 1);
    this.Date = this.Date.toISOString();
    //in this case ion-datetime will call ionChange event
  }


  get_user_rights(FUserId) {
    this.service.httpcall('web_service/get_users_rights?FUserId=' + FUserId).subscribe(data => {
      console.log(data['RightsData']);
      this.UserRights = data['RightsData'];
      if (this.UserRights != undefined) {
        console.log(this.School)
       this.loadvalues(this.SchoolData[this.School], this.FUserId);
      }
    })
  }

  active_tab(tab) {
    console.log(tab);
    this.School = tab;
    this.active_sub_tab(this.Active);
    // this.loadvalues(this.SchoolData[this.School], this.FUserId);
    //get types for that particular school only [{Enquiry:true,Admission:false}]
  }

  active_sub_tab(tab){
    console.log(tab);
    this.Active = tab;
    this.loadvalues(this.SchoolData[this.School], this.FUserId);

  }

  loadvalues(FSchoolId, FUserId) {
    let loading = this.loadingCtrl.create({
      content: 'Loading'
    });
    loading.present();
    setTimeout(() => {
      loading.dismiss();
    }, 5000);
    this.EnquiryData = [];
    this.datanotfound=null;
    console.log("FSchoolId", FSchoolId);

    this.service.httpcall('web_service/get_guest_data?FSchoolId=' + FSchoolId + '&FUserId=' + FUserId + '&IsArchive=' + this.IsArchiveData[this.Active]).subscribe(data => {
      loading.dismiss();
      console.log(data);
      if(data['response']=="success"){
        this.datanotfound=null;
        this.EnquiryData = data['data'];
      }else{
        this.datanotfound=data['error_description'];
      }

    })
  }


  open_enquiry_form2(item){

    let EnquiryModel = this.modalCtrl.create(EnquiryFormPage,{dataPlus:item});
    // EnquiryModel.onDidDismiss(data => {
    //   console.log(data);
    //   // this.loadvalues(this.SchoolData[this.School], this.FUserId, this.DisplayDate);
    //   // this.presentToast(data);
    // });
    EnquiryModel.present();

  }

  enquiry_call(enquirydata) {

    let myAlert = this.alertCtrl.create({
      title: 'Contacts',
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel',
          handler: () => {
            console.log('Cancel clicked');
          }
        },
        {
          text: 'Call',
          handler: (data) => {
            console.log('Message clicked');
            console.log(data);
            window.location.href = 'tel:'  + data;

          }
        }
      ]
    });
    myAlert.addInput({
      type: 'radio',
      label: enquirydata.MobileNumber,
      value: enquirydata.MobileNumber
    })
    myAlert.present();
  }

  whatsapp_call(enquirydata) {

    let myAlert = this.alertCtrl.create({
      title: 'Contacts',
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel',
          handler: () => {
            console.log('Cancel clicked');
          }
        },
        {
          text: 'Whatsapp',
          handler: (data) => {
            console.log('Message clicked');
            console.log(data);
            window.location.href = 'whatsapp://send?phone=+91' + data;
          }
        }
      ]
    });

    myAlert.addInput({
      type: 'radio',
      label: enquirydata.MobileNumber,
      value: enquirydata.MobileNumber
    })
    myAlert.present();


  }

  msg_call(enquirydata) {

    let myAlert = this.alertCtrl.create({
      title: 'Enquiry Contacts',
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel',
          handler: () => {
            console.log('Cancel clicked');
          }
        },
        {
          text: 'Message',
          handler: (data) => {
            console.log('Message clicked');
            console.log(data);
            window.location.href = 'sms:'  + data;
          }
        }
      ]
    });
    myAlert.addInput({
      type: 'radio',
      label: enquirydata.MobileNumber,
      value: enquirydata.MobileNumber
    })
    myAlert.present();
  }

  msg_Group(item){

    this.socialSharing.shareViaWhatsApp(item.SendWhatsAppGroupMsg, null, null);

  }

  addContact(){
    let contact: Contact = this.contacts.create();

    contact.name = new ContactName(null, 'Smith', 'John');
    contact.phoneNumbers = [new ContactField('mobile', '6471234567')];
    contact.save().then(
        () => console.log('Contact saved!', contact),
        (error: any) => console.error('Error saving contact.', error)
    );
  }

  add_contact(enquirydata){
    let myAlert = this.alertCtrl.create({
      title: 'Add Contacts',
      cssClass: 'custom_alert',
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel',
          handler: () => {
            console.log('Cancel clicked');
          }
        },
        {
          text: 'Add To Contact',
          handler: (phone_num) => {
            console.log(phone_num);
            if(phone_num != undefined){
              console.log(JSON.parse(phone_num));
              let UserDetails = JSON.parse(phone_num);
              console.log(UserDetails.Contact);
              let contactName="EQD ("+enquirydata.Id+") "+enquirydata.StudentName;
              console.log(contactName);
              let contact: Contact = this.contacts.create();
              //contact.name = new ContactName(null, FirstName, LastName);

              contact.name = new ContactName(null, 'Smith', 'John');
              contact.phoneNumbers = [new ContactField('mobile', '6471234567')];
              contact.save().then(
                  () => console.log('Contact saved!', contact),
                  (error: any) => console.error('Error saving contact.', error)
              );

              /*contact.name = new ContactName(null, contactName, null);
              contact.phoneNumbers = [new ContactField('mobile', UserDetails.Contact)];
              contact.save().then(
                  () =>{
                    console.log('Contact saved!', contact);
                    let toast = this.toastCtrl.create({
                      message: 'Contact saved!',
                      duration: 5000,
                      position: 'middle'
                    });
                    toast.present();
                  } ,
                  (error: any) => {
                    console.error('Error saving contact.', error);
                    let toast = this.toastCtrl.create({
                      message: 'Error saving contact.',
                      duration: 5000,
                      position: 'middle'
                    });
                    toast.present();
                  }
              );*/

            }else{
              let toast = this.toastCtrl.create({
                message: 'Please Select Contact',
                duration: 5000,
                position: 'bottom'
              });
              toast.present();
              return false;
            }


          }
        }
      ]
    });

    let Phone1 = {Contact:enquirydata.Phone1};
    let Phone2 = {Contact:enquirydata.Phone2};
    myAlert.addInput({
      type: 'radio',
      label: 'Phone1 :'+ enquirydata.Phone1 ,
      value: JSON.stringify(Phone1)
    })
    myAlert.addInput({
      type: 'radio',
      label: 'Phone2: ' + enquirydata.Phone2 ,
      value: JSON.stringify(Phone2)
    })
    myAlert.present();
  }

  add_appointment(item){
    let AppointmentModel = this.modalCtrl.create(AddAppointmentPage,{data:item});
    AppointmentModel.onDidDismiss(data => {
      console.log(data);
      this.loadvalues(this.SchoolData[this.School], this.FUserId);
      this.presentToast(data);
    });
    AppointmentModel.present();
  }
   sanitize(url: string) {
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
   }
  send_WPappointment(item){
    var link="http://geis.co.in/add_appointment.php?FWebEnquiryId="+item.Id+"&Name="+item.StudentName;
    console.log(encodeURI(link));
    let myAlert = this.alertCtrl.create({
      title: 'Send Whatsapp Message',
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel',
          handler: () => {
            console.log('Cancel clicked');
          }
        },
        {
          text: 'Whatsapp',
          handler: (data) => {
            console.log('Message clicked');
            console.log(data);
            //window.location.href = 'whatsapp://send?phone=+91' + data+'&text='+this.sanitize(link);
            this.socialSharing.shareViaWhatsAppToReceiver('+91'+data, "", null, encodeURI(link));
          }
        }
      ]
    });

    myAlert.addInput({
      type: 'radio',
      label: item.Phone1,
      value: item.Phone1
    })
    myAlert.addInput({
      type: 'radio',
      label: item.Phone2,
      value: item.Phone2
    })
    myAlert.present();
  }

  send_Msgappointment(item){
    var link="http://geis.co.in/add_appointment.php?FWebEnquiryId="+item.Id+"&Name="+item.StudentName;
    console.log(encodeURI(link));
    let myAlert = this.alertCtrl.create({
      title: 'Send Text Message',
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel',
          handler: () => {
            console.log('Cancel clicked');
          }
        },
        {
          text: 'Message',
          handler: (data) => {
            console.log('Message clicked');
            console.log(data);
            //window.location.href = 'whatsapp://send?phone=+91' + data+'&text='+this.sanitize(link);
            this.socialSharing.shareViaSMS(encodeURI(link),'+91'+data);
          }
        }
      ]
    });

    myAlert.addInput({
      type: 'radio',
      label: item.Phone1,
      value: item.Phone1
    })
    myAlert.addInput({
      type: 'radio',
      label: item.Phone2,
      value: item.Phone2
    })
    myAlert.present();
  }

  go_to_call_logs(item){
    let Call_logs_model = this.modalCtrl.create(DataCallLogPage,{data:item});
    // AppointmentModel.onDidDismiss(data => {
    //   console.log(data);
    // });
    Call_logs_model.present();
  }

  doRefresh(refresher) {
    console.log('Begin async operation', refresher);

    this.loadvalues(this.SchoolData[this.School], this.FUserId);
    setTimeout(() => {
      console.log('Async operation has ended');

      refresher.complete();
    }, 2000);
  }


  openFab(socialNet: string, fab: FabContainer) {
    fab.close();
    if (socialNet == "JustDialData") {
      this.open_JustDial_form(socialNet);
    }
  }

  open_JustDial_form(item){
    let Model = this.modalCtrl.create(AddJustdialDataPage);
    Model.onDidDismiss(data => {
      console.log(data);
      if (data == undefined) {
      } else {
        this.loadvalues(this.SchoolData[this.School], this.FUserId);
        this.presentToast(data);
      }


    });
    Model.present();
  }

  load_archive_status() {
    this.ArchiveStatus = [];
    this.service.httpcall('web_service/get_master_archive_status?').subscribe(data => {
      this.ArchiveStatus = data;
    })
  }

  select_archive(item) {
    let myAlert = this.alertCtrl.create({
      title: 'Select Archive',
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel',
          handler: () => {
            console.log('Cancel clicked');
          }
        },
        {
          text: 'Confirm',
          handler: (data) => {
            console.log('clicked');
            console.log(data);

            let loading = this.loadingCtrl.create({
              content: 'Loading'
            });
            loading.present();

            this.EnquiryData = [];
            this.datanotfound = null;
            console.log("Id", item.Id);
            this.service.httpcall('web_service/archive_guest_app_login?Id=' + item.Id+ '&IsJustDialData=' + item.IsJustDialData + '&ArchiveFor=' + data + '&ArchiveBy=' + this.FUserId).subscribe(data => {
              if (loading)
                loading.dismiss();
              loading = undefined;
              console.log(data);
              if (data['response'] == "success") {
                this.presentToast(data['success_message']);
                this.loadvalues(this.SchoolData[this.School], this.FUserId);
              } else {
                const alert = this.alertCtrl.create({
                  title: 'Error!',
                  subTitle: data['error_description'],
                  buttons: ['OK']
                });
                alert.present();
              }
            })

          }
        }
      ]
    });
    for (var i = 0; i < this.ArchiveStatus.length; i++) {
      this.ArchiveStatusItem = this.ArchiveStatus[i];
      var edata = this.ArchiveStatusItem.Name;
      console.log(edata);
      myAlert.addInput({
        type: 'radio',
        label: edata,
        value: this.ArchiveStatusItem.Id
      })
    }

    myAlert.present();
  }


}



// WEBPACK FOOTER //
// ./src/pages/guest/guest.ts